import { postFetch } from '../fetch';
import { apiConfig } from '../config';
import { Reaction, ReactionType, ReactionContextType, StickerReactionPayload } from '../../../typings';

export interface AssignClessonStudentsSticker {
    id: string;
    clessonId: number;
    courseId: number;
    slug: string;
    studentId: number;
}

export function assignClessonStudentsSticker(
    request: AssignClessonStudentsSticker[]
): Promise<Reaction<StickerReactionPayload>[]> {
    const { apiAssignReactionByMe } = apiConfig.getStaticUrls();
    const reactions = request.map((item): Partial<Reaction<StickerReactionPayload>> => {
        return {
            id: item.id,
            'receiver_id': item.studentId,
            'reaction_type': ReactionType.STICKER,
            'is_viewed': false,
            payload: {
                slug: item.slug,
                'course_id': item.courseId,
            },
            'context_id': String(item.clessonId),
            'context_type': ReactionContextType.CLESSON,
        };
    });

    return postFetch(apiAssignReactionByMe, { reactions });
}
